module.exports = __webpack_public_path__ + "img/Diego_Grajales.4e7dfee1.png";